import React from "react";
import "./../../Dashboard/SpinnerLoader/SpinerStyle.css";
function SpinnerLoader() {
  return (
    <div className="d-flex justify-content-center">
      <div className="loader"></div>
    </div>
  );
}

export default SpinnerLoader;
